export type NoticeCategory = 'urgent' | 'service' | 'loisirs' | 'personnalise' | 'municipal'

export interface Notice {
  id: string
  category: NoticeCategory
  title: string
  description: string
  when: string
  ago: string
  context?: string
  unread: boolean
}

export const categoryLabels: Record<NoticeCategory, string> = {
  urgent: 'Urgent',
  service: 'Service',
  loisirs: 'Recreation',
  personnalise: 'Personalized',
  municipal: 'Town news',
}

export const notices: Notice[] = [
  {
    id: 'ebullition',
    category: 'urgent',
    title: 'Boil water advisory',
    description: 'Your address is affected. Boil water for one minute before drinking it.',
    when: 'Today · 2:30 p.m.',
    ago: '12 min ago',
    context: '5108 - 46 Street',
    unread: true,
  },
  {
    id: 'collecte',
    category: 'service',
    title: 'Collection delayed',
    description: 'Thursday’s collection will take place Friday.',
    when: 'Yesterday · 4:10 p.m.',
    ago: 'yesterday',
    context: 'Zone 2',
    unread: true,
  },
  {
    id: 'natation',
    category: 'personnalise',
    title: 'Reminder — Junior swim',
    description: 'Emma’s lesson starts Saturday at 10 a.m. at the Bonnyville Swimming Pool.',
    when: 'Aug. 21',
    ago: 'Aug. 21',
    context: 'Emma Mickelson',
    unread: false,
  },
  {
    id: 'req-2841',
    category: 'service',
    title: 'Your request has been updated',
    description: 'Pothole — #REQ-2841 · New status: In progress',
    when: 'Aug. 28 · 9:05 a.m.',
    ago: 'Aug. 28',
    context: '5108 - 46 Street',
    unread: true,
  },
  {
    id: 'milo-rappel',
    category: 'personnalise',
    title: 'Reminder for Milo',
    description: 'Vaccination due October 14, 2026.',
    when: 'Aug. 20',
    ago: 'Aug. 20',
    context: 'Milo · pet card',
    unread: false,
  },
  {
    id: 'inscriptions',
    category: 'loisirs',
    title: 'Registration open',
    description: 'Fall program registration is now open.',
    when: 'Aug. 25',
    ago: 'Aug. 25',
    unread: false,
  },
  {
    id: 'travaux',
    category: 'service',
    title: 'Roadwork on 50 Avenue',
    description: 'Local traffic only until September 13.',
    when: 'Aug. 19',
    ago: 'Aug. 19',
    context: '400 m from your address',
    unread: false,
  },
  {
    id: 'conseil',
    category: 'municipal',
    title: 'Regular council meeting',
    description: 'Next regular council meeting on Tuesday, September 22.',
    when: 'Aug. 14',
    ago: 'Aug. 14',
    unread: false,
  },
]

export const activeAlert = {
  title: 'Boil water advisory — your address is affected',
  address: '5108 - 46 Street',
  addressLabel: 'Primary address',
  since: 'Since today, 2:30 p.m.',
  summary:
    'A boil water advisory is currently in effect for this address on your profile.',
  concerns: '5108 - 46 Street falls inside the affected area.',
  todo: 'Boil water for at least one minute before drinking it, as set out in the Town’s official advisory.',
  questions: ['Can I drink the water?', 'Can I give it to my pet?', 'When will the advisory be lifted?'],
}

export const resolvedAlert = {
  title: 'Boil water advisory lifted — Zone 2',
  detail: 'The water has been safe to drink since August 24 at 4 p.m.',
}

export const avisChips = ['My important alerts', 'Unread', 'This week', 'Settings']

export const avisQuestions = [
  'Why did I get this notice?',
  'Which notices are essential?',
  'How do I change my phone number?',
  'Which addresses are linked to my alerts?',
]

export interface ChannelPref {
  id: string
  label: string
  destination: string
  enabled: boolean
}

export const channelPrefs: ChannelPref[] = [
  { id: 'push', label: 'Mobile notifications', destination: 'bciti+ app', enabled: true },
  { id: 'courriel', label: 'Email', destination: 'bryon.mickelson@example.com', enabled: true },
  { id: 'sms', label: 'Text message', destination: '(780) •••-0184', enabled: false },
]

export interface TopicPref {
  id: string
  label: string
  description: string
  enabled: boolean
}

export const topicPrefs: TopicPref[] = [
  { id: 'collectes', label: 'Collections', description: 'Collection reminders and changes', enabled: true },
  { id: 'loisirs', label: 'Recreation and culture', description: 'Registration, reminders and changes', enabled: true },
  { id: 'travaux', label: 'Roadwork and traffic', description: 'Roadwork, closures and local impacts', enabled: true },
  { id: 'municipal', label: 'Town news', description: 'Town news and information', enabled: false },
  {
    id: 'personnalise',
    label: 'Personalized services',
    description: 'Information tied to the services you use',
    enabled: true,
  },
]

export const alertPlaces = [
  { id: 'principale', address: '5108 - 46 Street', label: 'Primary address' },
  { id: 'secondaire', address: '4703 - 51 Avenue', label: 'Second property' },
]
